import * as marietta from '..';
import * as marietta3d from '../../marietta3d';
import * as graphicLibs from '../graphicLibs';
import { BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, FREETEXT_ITEMCODE, ITEM_MODE_KEY, ITEM_MODE_NO } from './Constants';
import { MonicaObject } from './item';

// 2Dで高さ・設置高さを編集できるアイテムのID接頭辞（住設・家具）
const HEIGHT_EDITABLE_ITEM_PREFIXES: readonly string[] = ['fur', 'equ'];
const ITEM_ID_PREFIX_LENGTH: number = 3;

export default class WebCADGlobal {
    // アプリ情報
    static APP_NAME: string = 'WebCAD';

    static APP_VERSION: string = ''; // 変更する時は、config.xmlを書き換えればいいよ。

    static API_VERSION: string = '0.0'; // CADAPI（計算API） version

    static APP_CUSTOM: string = 'STARTS';

    static APP_REVISION: string;

    // 1グリッドあたりのピクセル数
    static PIX_IN_GRID: number = 60;

    // 1帖あたりのM数
    static M_IN_JYO: number = 0.91;

    // MAX階数
    static MAX_FLOORS: number = 3;

    // モジュール一覧
    // 戸建てモード house: 0 ,マンションモード mansion: 1
    static MODULE_LIST: any = {
      0: [
        { label: '910mm', value: 910 },
        { label: '1000mm', value: 1000 },
      ],
      1: [
        { label: '1000mm', value: 1000 },
      ],
    };

    // モジュールピッチ（寸法モード）関連の既定値
    static readonly MODULE_PITCH_DEFAULT: number = 910;                 // モジュール補正選択時の既定ピッチ(mm)。撮影アプリ/保存データ由来値が無い場合のフォールバック
    static readonly MODULE_PITCH_MIN: number = 500;                     // モジュールピッチの下限(mm)
    static readonly MODULE_PITCH_MAX: number = 2000;                    // モジュールピッチの上限(mm)
    static readonly MODULE_PITCH_FREE_OPTION: string = 'free';         // モジュール選択コンボボックスの「フリー寸法」選択肢値
    static readonly MODULE_PITCH_MODULE_OPTION: string = 'module';     // モジュール選択コンボボックスの「モジュール補正」選択肢値
    static readonly MODULE_LABEL_FREE: string = 'フリー寸法';            // フリー寸法選択肢の表示ラベル
    static readonly MODULE_LABEL_MODULE: string = 'モジュール補正';       // モジュール補正選択肢の表示ラベル
    static readonly MODULE_LABEL_UNIT: string = 'mm';                  // モジュール補正時のピッチ表示単位（例: 910mm）。編集中（フォーカス中）は外す

    static WALL_COLOR: number = 0x666666;

    static WALL_WIDTH: number = 10;

    // ###############   OUTERFRAME   ###############
    static OUTERFRAME_HEADER_HEIGHT: number = 40;

    static OUTERFRAME_FOOTER_HEIGHT: number = 50;

    static OUTERFRAME_LEFT_FRAME_WIDTH: number = 50;

    // ###############   ITEM   ###############
    static SETTING_ROOM_TEXT_SIZE: number = 16;

    // ###############   LAYER   ###############
    // スケール
    static layerScaleMin: number = 0.2; // 最小拡大率

    static LAYER_SCALE_MAX: number = 5; // 最大拡大率

    static get LAYER_SCALE_MIN(): number {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile) return marietta.webcad.WebCADGlobal.layerScaleMin / 2;
      return marietta.webcad.WebCADGlobal.layerScaleMin;
    }

    // レイヤーサイズ
    static LAYER_SIZE_W: number = 60 * 120;

    static LAYER_SIZE_H: number = 60 * 80;

    // 間取りのマージンFitWindow用マージン
    static LAYER_MARGIN: number = 50; //150;

    // ###############   MODE   ###############
    static modeList = ['SITE', 'EXTERIOR', 'STAIR', 'ROOM', 'FITTING', 'EQUIPMENT', 'FURNITURE', 'PRESENT', 'ROOF'];

    static MAX_MODE: number = 7;

    // gridLayerで結合する正方形の数
    static mergeSquareUnit: number = 5;

    // 下絵デフォルトの不透明度
    static SHITAE_OPACITY = 50;

    // 部屋文字のサイズ
    static ROOM_TEXT_SIZE: number = 11;

    // Monicaオブジェクトの変形できるMAXサイズ
    static MAX_SIZE_CHANGE_MONICA: number = 99999;

    // 2Dマネージャー
    static webcad2Dmanager: marietta.webcad.manager.Plan2DManager;

    // モジュール（寸法モード・ピッチ方針）マネージャー
    static moduleManager: marietta.webcad.manager.ModuleManager;

    // アイテムマネージャー
    static itemManager: marietta.webcad.manager.ItemManager;

    // 追加ピン取込みマネージャー
    static lidarAddPinManager: marietta.webcad.manager.AddLidarPinManager;

    // レイヤーグループ
    static layerGroup: marietta.webcad.layer.LayerGroup;

    // ユーザーエージェントマネージャ
    static userAgentManager: marietta.webcad.manager.UserAgentManager;

    // スクロールマネージャー
    static scrollerManager: marietta.webcad.manager.ScrollerManager;

    // CadAPIマネージャー
    static cadAPIManager: marietta.webcad.manager.CadAPIManager;

    // 建物のスタイルマネージャー
    static buildStyleManager: marietta.webcad.manager.BuildStyleManager;

    // ミニマップマネージャー
    static miniMapManager: marietta.webcad.manager.MiniMapManager;

    // ミニマップマネージャー
    static tabManager: marietta.webcad.manager.TabManager;

    // プラン画像
    static planPictManager: marietta.webcad.manager.PlanImageManager;

    // モジュール選択コンボボックス（ヘッダーのピッチ入力欄＋寸法モードドロップダウン）
    static modulePitchCombo: marietta.webcad.view.ModulePitchCombo;

    // アイテムリスト（フッターポップアップリスト）
    static quotationItemList: marietta.webcad.view.QuotationItemList;

    // 重なったアイテムのリスト表
    static overlapItemList: marietta.webcad.view.OverlapItemList;

    // アイテムメニューカテゴリ
    static itemMenuCategories: marietta.webcad.view.ItemMenuCategories;

    // アイテムメニュー
    static itemMenu: marietta.webcad.view.ItemMenu;

    // アイテムメニューカテゴリ3d
    static itemChangeMenuCategories3d: marietta.webcad.view.ItemChangeMenuCategories3d;

    // アイテムメニュー3d
    //        static itemChangeMenu3d: marietta.webcad.view.ItemChangeMenu3d;
    static changeHeightMenu: marietta.webcad.view.leftMenu3d.ChangeHeightMenu;

    static roofColorMenu: marietta.webcad.view.leftMenu3d.RoofColorMenu;

    static roofShapeMenu: marietta.webcad.view.leftMenu3d.RoofShapeMenu;

    static outColorMenu: marietta.webcad.view.leftMenu3d.OutColorMenu;

    static sashColorMenu: marietta.webcad.view.leftMenu3d.SashColorMenu;

    static innerColorMenu: marietta.webcad.view.leftMenu3d.InnerColorMenu;

    static designOptionMenu: marietta.webcad.view.leftMenu3d.DesignOptionMenu;

    static innerDesignOptionMenu: marietta.webcad.view.leftMenu3d.InnerDesignOptionMenu;

    static LIBRARY_SETITEMS: any[] = [];

    static LIBRARY_ITEMSLIST = new Map();

    static onStageResized: Function;

    // アイテムコントロールパネル
    static itemControlPanel: marietta.webcad.view.ItemControlPanel;

    // 2D/3Dボタンイベント
    static dimensionMenu: marietta.webcad.view.DimensionMenu;

    // 方位マーク
    static siteCompass: marietta.webcad.item.parts.Compass;

    // スナップマネージャー
    static snapManager: marietta.webcad.manager.SnapManager;

    //マスタマネージャー
    static masterManager:marietta.webcad.manager.MasterManager;

    // シェアモードマネージャー（アカウントを持たないユーザーの起動）
    static shareModeManager: marietta.webcad.manager.ShareModeManager;

    // 現在のダイアログ
    static _currentDialog;

    static get currentDialog() : marietta.core.view.Dialog { return this._currentDialog; }

    static set currentDialog(dialogClass: marietta.core.view.Dialog) { this._currentDialog = dialogClass; }

    // 最前面のダイアログ
    static _dialogList = [];

    static get dialogList(): (marietta.core.view.Dialog | marietta.core.view.Alert | marietta.core.view.ConfirmDialog)[] { return this._dialogList; }

    static set dialogList(dialogList: (marietta.core.view.Dialog | marietta.core.view.Alert | marietta.core.view.ConfirmDialog)[]) { this._dialogList = dialogList; }

    // 現在のLayerGroupのスケールサイズ
    static scaleSize: number = 1;

    // 現在のLayerGroupの座標
    static gridChart: marietta.core.Point = new marietta.core.Point(0, 0);

    // 自動回転アイテム（config.xmlより読み込んで保管）
    static AUTOFACING_ITEMS: string[] = [];

    // 3Dを持たないアイテム（config.xmlより読み込んで保管）
    static NON3D_ITEMS: string[] = [];

    // 建具設定情報
    static FITTING_CONFIG_ITEMS: any[] = [];

    /** 付帯工事マスタデータ */
    static AUXILIARY_MASTER: marietta.webcad.manager.auxiliaryMaster;

    /** 修繕理由マスタデータ */
    static REPAIR_MASTER: marietta.webcad.manager.repairMaster;

    static svgManager: marietta.webcad.manager.SvgManager;

    // Busyカウンタ
    static busyCounter: number = 0;

    // 階数変更後のアクション
    static onFloorChanged: Function;

    // アップロードウィンドウ表示
    static isUploadDialog: boolean;

    static autoMain: marietta3d.manager.AutoMain;

    // performanceCheck checkbox show/hide flag in help menu
    static performanceCheckDisplay: boolean = true;

    static scene: graphicLibs.Scene;

    static minMaxFittingWidth = { min: 200, max: 999000 };

    // テキストのフォントサイズリスト
    static freeTextFontSizeList: string[] = ['10', '10.5', '11', '12', '14', '15', '16', '18', '20', '24', '25', '28', '30', '40', '50', '60'];

    // テキストカラーリスト
    static freeTextColorList: string[] = ['#FFFFFF', '#000000', '#777777', '#C00000', '#FF0000', '#FFC000', '#FFFF00', '#92D050', '#00B050', '#00B0F0', '#0070C0', '#002060', '#7030A0'];

    // テキストフォントファミリ
    static freeTextFontFamily: string = 'sans-serif';

    static pinPanoramaCategory: {id: number, item_code: string, name: string, label:string, label_en:string}[] = [
      {
        id: 1, item_code: '04_01', name: '天井', label: '天井', label_en: 'Ceiling',
      },
      {
        id: 2, item_code: '04_02', name: '壁', label: '壁', label_en: 'Wall',
      },
      {
        id: 3, item_code: '04_03', name: '床', label: '床', label_en: 'Floor',
      },
    ];

    static pinPictureCategory: {id: number, item_code: string, name: string, label:string, label_en:string}[] = [
      {
        id: 1, item_code: '03_01', name: '写真', label: '写真', label_en: 'Picture',
      }
    ];

    static pinTextCategory: {id: number, item_code: string, name: string, label:string, label_en:string}[] = [
      {
        id: 1, item_code: '02_01', name: '天井', label: '天井', label_en: 'Ceiling',
      },
      {
        id: 2, item_code: '02_02', name: '壁', label: '壁', label_en: 'Wall',
      },
      {
        id: 3, item_code: '02_03', name: '床', label: '床', label_en: 'Floor',
      },
    ];

    static outerWallThicknessList = [0, 100, 150, 200, 250];

    static roomtextFontSize = 16;

    /**
     * 言語
     */
    static _language: string = 'jp';

    static get language(): string {
      return this._language;
    }

    static set language(value: string) {
      this._language = value;
    }

    /**
     * デモモードか否か
     */
    static get IS_DEMO_MODE(): boolean {
      return false;
      //
      // switch( marietta.webcad.WebCADGlobal.webcad2Dmanager.domain ){
      //     case "myhome-cloud.net":
      //         return false;
      // }
      // return true;
    }

    // デバッグモード
    static _DEBUG_MODE: boolean = false;

    static get DEBUG_MODE(): boolean {
      return marietta.webcad.WebCADGlobal._DEBUG_MODE;
    }

    static set DEBUG_MODE(val: boolean) {
      if (val) {
        $(".forDebug").show();
      } else {
        $(".forDebug").hide();
      }
      marietta.webcad.WebCADGlobal._DEBUG_MODE = val;
    }

    /**
     * キャッシュの効かないURLへ変更
     */
    static covertToNoCacheURL(url: string): string {
      let retString: string = url;

      // もうすでにGETパラメータがあれば最後に付与
      if (url.indexOf('?') > -1) {
        if (url.charAt(url.length - 1) !== '&') {
          retString += '&';
        }
      } else {
        retString += '?';
      }
      retString += `ver.${marietta.webcad.WebCADGlobal.APP_VERSION}`;
      return retString;
    }

    /**
     * アイテムKEYよりモード番号を取得
     * */
    static getModeNoFromKey(id: string): number {
      // 最初の3文字を取得
      const key: string = id.substring(0, 3);

      let tarString: string;
      for (let i = 0; i < marietta.webcad.WebCADGlobal.modeList.length; i += 1) {
        tarString = marietta.webcad.WebCADGlobal.modeList[i];
        if (marietta.webcad.WebCADGlobal[`MODE_${tarString}_KEY`] === key) {
          return marietta.webcad.WebCADGlobal[`MODE_${tarString}_NO`];
        }
      }
      return NaN;
    }

    /**
     * アイテムNOよりキーを取得
     * */
    static getModeKeyFromNo(no: number): string {
      // 最初の3文字を取得
      const modeTypeName = marietta.webcad.WebCADGlobal.modeList[no - 1];
      return marietta.webcad.WebCADGlobal[`MODE_${modeTypeName}_KEY`];
    }

    /**
     * メニュー幅
     */
    static get menuWidth(): number {
      return document.getElementById('itemMenuWrap').offsetWidth;
    }

    /**
     * ヘッダーの高さ
     */
    static get headerHeight(): number {
      return document.getElementById('header').offsetHeight;
    }

    /**
     * フッターの高さ
     */
    static get footerHeight(): number {
      return document.getElementById('footer').offsetHeight;
    }

    /**
     * Window幅
     */
    static get viewWidth(): number {
      return window.innerWidth - marietta.webcad.WebCADGlobal.menuWidth;
    }

    /**
     * Window高さ
     */
    static get viewHeight(): number {
      return window.innerHeight - marietta.webcad.WebCADGlobal.headerHeight - marietta.webcad.WebCADGlobal.footerHeight;
    }

    /**
     * ダイアログを表示
     * @param {marietta.core.view.Dialog} dialogClass - ダイアログクラス
     * @param {boolean} draggable - ダイアログをドラッガブルに
     * @param {boolean} modal - モーダル背景のオン/オフ
     * @param {boolean} modalEvent - モーダル背景に閉じるボタンの機能をつける
     * @param {boolean} closePrevious -
     * @param {Object} parameters -
     */
    static showDialog(DialogClass, draggable: boolean = false, modal: boolean = true, modalEvent: boolean = true, closePrevious: boolean = true, parameters: Object = null): marietta.core.view.Dialog {
      if (DialogClass == null) return null;
      // 前のものを閉じる
      if (closePrevious && this.currentDialog != null) {
        this.removeDialog();
      }

      // 作成
      const prevDialog = this.currentDialog != null ? { ...this.currentDialog } : null;
      this.currentDialog = new DialogClass(draggable, modal);

      // パラメータ
      // if (parameters !== null) {
      //   Object.entries(parameters).forEach(([, param]) => {
      //     // eslint-disable-next-line no-prototype-builtins
      //     if (this.currentDialog.hasOwnProperty(param)) {
      //       this.currentDialog[param] = parameters[param];
      //     }
      //   });
      // }
      for (let param in parameters) {
        if (this.currentDialog.hasOwnProperty(param)) {
          this.currentDialog[param] = parameters[param];
        }
      }
      // パラメータが必要な場合、コンテンツのビルドをこちらでおこなってもよい.
      this.currentDialog.buildContent();

      if (!closePrevious && prevDialog != null) {
        this.currentDialog.prevDialog = prevDialog as marietta.core.view.Dialog;
      }

      // ダイアログのイベント設定
      if (modal) {
        if (modalEvent) {
          // document.querySelector('#modalBg')[0].addEventListener('click', this.removeDialog);
          document.getElementById('modalBg').addEventListener('click', marietta.webcad.WebCADGlobal.removeDialog);
        }
      }

      // 中央に寄せる
      this.currentDialog.centerDialog();

      // 作成
      (this.currentDialog as marietta.core.view.Dialog).globalCleanUpFunc = this.onRemovedDialog;

      // 表示中のダイアログとして保存する
      marietta.webcad.WebCADGlobal.dialogList.push(this.currentDialog);

      // 最前面のダイアログをescキーで閉じる
      // this.addEscCloseEvent();

      return this.currentDialog;
    }

    /**
     * ActivationErrorダイアログを表示
     * @param {string} メッセージ
     * @param {string} タイトル
     */
    static showActivationErrorAlert(message: string):void {
      // 前のものを閉じる
      this.removeDialog();

      // 作成
      const dialog = new marietta.webcad.view.dialog.ActivationErrorAlert(message);

      // ダイアログのイベント設定
      document.getElementById('modalBg').style.display = 'block';
      // 中央に寄せる
      dialog.centerDialog();

      // 作成
      dialog.globalCleanUpFunc = this.onRemovedDialog;

      // 表示中のダイアログとして保存する
      marietta.webcad.WebCADGlobal.dialogList.push(dialog);

      // 最前面のダイアログをescキーで閉じる
      // this.addEscCloseEvent();
    }

    /**
     * ダイアログを表示
     * @param {string} メッセージ
     * @param {string} タイトル
     */
    static showAlert(message: string, title: string = '', callBack: () => void = null, showHeaderCloseButton: boolean = true, isCenterText: boolean = false):void {
      const alert: marietta.core.view.Alert = new marietta.core.view.Alert();
      alert.show(message, title, callBack, showHeaderCloseButton, this.currentDialog ? this.currentDialog : null, isCenterText);

      // ダイアログのイベント設定
      document.getElementById('modalBg').style.display = 'block';

      // 中央に寄せる
      alert.centerDialog();

      // 作成
      alert.globalCleanUpFunc = this.onRemovedDialog;

      // 表示中のダイアログとして保存する
      marietta.webcad.WebCADGlobal.dialogList.push(alert);

      // 最前面のダイアログをescキーで閉じる
      // this.addEscCloseEvent();
    }

    /**
     * 確認ダイアログを表示
     * @param {string} メッセージ
     * @param {string} タイトル
     * @param callBackOK
     * @param callBackNO
     */
    static showConfirmDialog(message: string, title: string = '', cbOK: Function = null, cbNG: Function = null, showHeaderCloseButton: boolean = true) {
      const dialog: marietta.core.view.ConfirmDialog = new marietta.core.view.ConfirmDialog();
      dialog.show(message, title, cbOK, cbNG, showHeaderCloseButton, this.currentDialog ? this.currentDialog : null);

      // ダイアログのイベント設定
      // document.getElementById('modalBg').style.display = 'block';

      // 中央に寄せる
      dialog.centerDialog();

      // 作成
      dialog.globalCleanUpFunc = this.onRemovedDialog;

      // 表示中のダイアログとして保存する
      marietta.webcad.WebCADGlobal.dialogList.push(dialog);

      // 最前面のダイアログをescキーで閉じる
      // this.addEscCloseEvent();
    }

    /**
     * ダイアログを消す際のお掃除
     */
    static removeDialog = () => {
      if (!marietta.webcad.WebCADGlobal.currentDialog) return;

      // ダイアログを閉じる
      marietta.webcad.WebCADGlobal.currentDialog.closeEvent();
    }

    /**
     * ダイアログを消す際のお掃除
     */
    static onRemovedDialog() {
      // モーダルのお掃除、メモリのお掃除
      if (document.getElementById('dialogContainer').querySelectorAll('.dialogBox').length < 1) {
        document.getElementById('modalBg').style.display = 'none';
        document.getElementById('modalBg').removeEventListener('click', marietta.webcad.WebCADGlobal.removeDialog);
        marietta.webcad.WebCADGlobal.currentDialog = null;
      }
      // ダイアログリストから登録を削除
      marietta.webcad.WebCADGlobal.dialogList.pop();
      if (!marietta.webcad.WebCADGlobal.dialogList.length) {
        marietta.webcad.WebCADGlobal.removeEscCloseEvent();
      }
    }

    /*
    * 最前面のダイアログをescキーでcloseする
    */
    static escCloseEvent = (e) => {
      if (e.key === 'Escape' && marietta.webcad.WebCADGlobal.dialogList.length) {
        // モード選択ダイアログはcloseさせない。
        if (marietta.webcad.WebCADGlobal.dialogList[marietta.webcad.WebCADGlobal.dialogList.length - 1] instanceof marietta.webcad.view.dialog.BuildingTypeSelectDialog) return;
        marietta.webcad.WebCADGlobal.dialogList[marietta.webcad.WebCADGlobal.dialogList.length - 1].close();
      }
    };

    // escキーイベントの追加
    static addEscCloseEvent() {
      document.addEventListener('keydown', marietta.webcad.WebCADGlobal.escCloseEvent);
    }

    // escキーイベントの削除
    static removeEscCloseEvent() {
      document.removeEventListener('keydown', marietta.webcad.WebCADGlobal.escCloseEvent);
    }

    /**
     * 部屋種別ごとの設定の取得
     */
    static getRoomConfig(id: string) {
      const setting: marietta.webcad.collection.RoomConfigCollection = new marietta.webcad.collection.RoomConfigCollection();
      // 色
      switch (id.substring(0, 5)) {
        case 'rom01': setting.color = '#F3F3F3'; break;
        case 'rom02': setting.color = '#F4F1EA'; break;
        case 'rom03': setting.color = '#F3F3F3'; break;
        case 'rom04': setting.color = '#FEFBF1'; break;
        case 'rom05': setting.color = '#FEFBF1'; break;
        case 'rom06': setting.color = '#FEFBF1'; break;
        case 'rom07': setting.color = '#F4FCFF'; break;
        case 'rom08': setting.color = '#F4FCFF'; break;
        case 'rom09': setting.color = '#F4FCFF'; break;
        case 'rom11': setting.color = '#FFFFFF'; break;
        case 'rom10': setting.color = '#FEFBF1'; break;
        case 'rom12': setting.color = '#F4F1EA'; break;
        case 'rom13': setting.color = '#F4F1EA'; break;
        case 'rom14': setting.color = '#FEFBF1'; break;
        case 'rom15': setting.color = '#FEFBF1'; break;
        case 'rom16': setting.color = '#F4F1EA'; break;
        case 'rom17': setting.color = '#FFFFFF'; break;
        case 'rom18': setting.color = '#F4F1EA'; break;
        case 'rom25': setting.color = '#FEFBF1'; break;
        case 'rom26': setting.color = '#FEFBF1'; break;
        case 'rom27': setting.color = '#F3F3F3'; break;
        case 'rom28': setting.color = '#F4F1EA'; break;
        case 'col01': setting.color = '#666666'; break;
        case 'bem01': setting.color = '#666666'; break;
        default: setting.color = '#FFFFFF'; break;
      }
      // 模様の色
      switch (id.substring(0, 5)) {
        case 'rom01': setting.designColor = '#777777'; break;
        case 'rom03': setting.designColor = '#666666'; break;
        case 'rom09': setting.designColor = '#FFFFFF'; break;
        case 'rom10': setting.designColor = '#D9A300'; break;
        case 'rom28': setting.designColor = '#686859'; break;
        default: setting.designColor = '#000000'; break;
      }
      // 壁の設定
      switch (id.substring(0, 5)) {
        case 'rom01':
        case 'col01':
        case 'bem01':
          setting.wallType = 0; break; // 開口
        case 'rom18': setting.wallType = 2; break; // 腰壁
        default: setting.wallType = 1; break; // 全面壁
      }
      // 部屋名
      if (marietta.webcad.WebCADGlobal.language === 'jp') {
        switch (id.substring(0, 5)) {
          case 'rom01': setting.text = 'ポーチ'; break;
          case 'rom02': setting.text = '廊下'; break;
          case 'rom03': setting.text = '玄関'; break;
          case 'rom04': setting.text = 'ﾘﾋﾞﾝｸﾞ'; break;
          case 'rom05': setting.text = 'ﾀﾞｲﾆﾝｸﾞ'; break;
          case 'rom06': setting.text = 'ｷｯﾁﾝ'; break;
          case 'rom07': setting.text = '洗面所'; break;
          case 'rom08': setting.text = 'トイレ'; break;
          case 'rom09': setting.text = '浴室'; break;
          case 'rom10': setting.text = '洋室'; break;
          case 'rom11': setting.text = '和室'; break;
          case 'rom12': setting.text = '床の間'; break;
          case 'rom13': setting.text = '広縁'; break;
          case 'rom14': setting.text = '収納'; break;
          case 'rom15': setting.text = '書斎'; break;
          case 'rom16': setting.text = '階段'; break;
          case 'rom17': setting.text = '吹抜'; break;
          case 'rom18': setting.text = 'ﾊﾞﾙｺﾆｰ'; break;
          case 'rom19': setting.text = '階段室'; break;
          case 'rom21': setting.text = '小屋裏'; break;
          case 'rom22': setting.text = '小屋裏収納'; break;
          case 'rom23': setting.text = 'ロフト'; break;
          case 'rom24': setting.text = 'ＷＩＣ'; break;
          case 'rom25': setting.text = 'LD'; break;
          case 'rom26': setting.text = 'LDK'; break;
          case 'rom27': setting.text = 'ｶﾞﾚｰｼﾞ'; break;
          case 'rom28': setting.text = '土間'; break;
          case 'rom36': setting.text = 'PS'; break;
          case 'rom37': setting.text = 'MB'; break;

          default: setting.text = ''; break;
        }
      } else {
        // 部屋名(En)
        switch (id.substring(0, 5)) {
          case 'rom01': setting.text = 'Porch'; break;
          case 'rom02': setting.text = 'Hallway'; break;
          case 'rom03': setting.text = 'Entrance'; break;
          case 'rom04': setting.text = 'Living'; break;
          case 'rom05': setting.text = 'Dining'; break;
          case 'rom06': setting.text = 'Kitchen'; break;
          case 'rom07': setting.text = 'Restroom'; break;
          case 'rom08': setting.text = 'Toilet'; break;
          case 'rom09': setting.text = 'Bath'; break;
          case 'rom10': setting.text = 'Bedroom'; break;
          case 'rom11': setting.text = 'Washitu'; break;
          case 'rom12': setting.text = 'Tokonoma'; break;
          case 'rom13': setting.text = 'Hiroen'; break;
          case 'rom14': setting.text = 'Storage'; break;
          case 'rom15': setting.text = 'Study'; break;
          case 'rom16': setting.text = 'Stair'; break;
          case 'rom17': setting.text = 'Stairwell'; break;
          case 'rom18': setting.text = 'Balcony'; break;
          case 'rom19': setting.text = 'Staircase'; break;
          case 'rom21': setting.text = 'Attic'; break;
          case 'rom22': setting.text = 'Attic storage'; break;
          case 'rom23': setting.text = 'Loft'; break;
          case 'rom24': setting.text = 'ＷＩＣ'; break;
          case 'rom25': setting.text = 'LD'; break;
          case 'rom26': setting.text = 'LDK'; break;
          case 'rom27': setting.text = 'Garage'; break;
          case 'rom28': setting.text = 'Doma'; break;

          default: setting.text = ''; break;
        }
      }

      // デザインタイプ
      switch (id.substring(0, 5)) {
        case 'rom01': setting.design_type = 'koushi_2'; break;
        case 'rom03': setting.design_type = 'koushi_1'; break;
        case 'rom09': setting.design_type = 'koushi_3'; break;
        // case 'rom10': setting.design_type = 'pattern_4'; break;
        case 'rom28': setting.design_type = 'koushi_1'; break;
        default: setting.design_type = null; break;
      }

      setting.text_area_visible = false;
      // 部屋サイズを表示する場合
      switch (id) {
        case 'rom04_01':
        case 'rom05_01':
        case 'rom10_01':
        case 'rom11_01':
        case 'rom15_01':
        case 'rom25_01':
        case 'rom26_01':
          setting.text_area_visible = true;
          break;
        default:
          break;
      }

      setting.text_visible = true;
      // 部屋名を表示しない場合
      switch (id) {
        case 'rom01_01':
        case 'rom13_01':
        case 'rom18_01':
        case 'rom00_01':
          setting.text_visible = false;
          break;
        default:
          break;
      }

      // 帖表記
      setting.area_use_jyou = false;
      switch (id) {
        case 'rom10_01':
        case 'rom11_01':
          setting.area_use_jyou = true;
          break;
        default:
          break;
      }

      // デフォルトサイズ
      switch (id.substring(0, 5)) {
        // ポーチ
        case 'rom01':
          setting.default_width = 120;
          setting.default_depth = 60;
          break;
          // 廊下
        case 'rom02':
          setting.default_width = 60;
          setting.default_depth = 180;
          break;
          // 玄関
        case 'rom03':
          setting.default_width = 120;
          setting.default_depth = 60;
          break;
          // ﾘﾋﾞﾝｸﾞ
          // ﾀﾞｲﾆﾝｸﾞ
        case 'rom04':
        case 'rom05':
          setting.default_width = 240;
          setting.default_depth = 180;
          break;
          // ｷｯﾁﾝ
        case 'rom06':
          setting.default_width = 240;
          setting.default_depth = 120;
          break;
          // 洗面所
        case 'rom07':
          setting.default_width = 120;
          setting.default_depth = 120;
          break;
          // トイレ
        case 'rom08':
          setting.default_width = 60;
          setting.default_depth = 120;
          break;
          // 浴室
        case 'rom09':
          setting.default_width = 120;
          setting.default_depth = 120;
          break;
          // 洋室
        case 'rom10':
          setting.default_width = 240;
          setting.default_depth = 180;
          break;
          // 和室
        case 'rom11':
          setting.default_width = 180;
          setting.default_depth = 180;
          break;
          // 床の間
        case 'rom12':
          setting.default_width = 60;
          setting.default_depth = 60;
          break;
          // 広縁
        case 'rom13':
          setting.default_width = 180;
          setting.default_depth = 60;
          break;
          // 収納
        case 'rom14':
          setting.default_width = 120;
          setting.default_depth = 60;
          break;
          // 書斎
          // 吹抜
        case 'rom17':
        case 'rom15':
          setting.default_width = 120;
          setting.default_depth = 120;
          break;
          // ﾊﾞﾙｺﾆｰ
        case 'rom18':
          setting.default_width = 180;
          setting.default_depth = 60;
          break;
          // LD
        case 'rom25':
          setting.default_width = 240;
          setting.default_depth = 240;
          break;
          // LDK
        case 'rom26':
          setting.default_width = 240;
          setting.default_depth = 360;
          break;
          // ｶﾞﾚｰｼﾞ
        case 'rom27':
          setting.default_width = 180;
          setting.default_depth = 300;
          break;
          // その他
        default:
          setting.default_width = 120;
          setting.default_depth = 120;
          break;
      }

      return setting;
    }

  /**
   * 巾木のある部屋か
   * @param id
   */
    static isRoomWithHabaki( id:string ):boolean{
        switch (id.substring(0, 5)) {
          case 'rom01':
          case 'rom09':
          case 'rom13':
          case 'rom17':
          case 'rom18':
          case 'rom27':
          case 'rom36':
          case 'rom37':
            return false;
        }
        return true;
    }

    /**
     * 部屋のitemInfoの初期設定をセット
     */
    /* eslint no-param-reassign: ["error", { "props": false }] */
    static setDefaultRoomSetting(info: marietta.webcad.collection.ItemInfoCollection): marietta.webcad.collection.ItemInfoCollection {
      const roomInfo: marietta.webcad.collection.RoomConfigCollection = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
      info.text = roomInfo.text;
      info.color = roomInfo.color;
      info.design_type = roomInfo.design_type;
      info.designColor = roomInfo.designColor;
      info.text_visible = roomInfo.text_visible;
      info.text_area_visible = roomInfo.text_area_visible;
      info.area_use_jyou = roomInfo.area_use_jyou;
      return info;
    }

    /**
     * 階段のドット情報の取得
     */
    static getStairDotList(id: string) {
      const retList: marietta.webcad.collection.PointCollection[] = [];
      switch (id) {
        case 'str01_01':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, 60, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, 60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 0, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 0, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 60, 0));
          break;
        case 'str02_01':
        case 'str02_02':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 20, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, 60, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, 60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 0, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 20, 0));
          break;
        case 'str03_01':
          retList.push(new marietta.webcad.collection.PointCollection(-30, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-30, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, 30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, 90, 1));
          break;
        case 'str04_01':
          retList.push(new marietta.webcad.collection.PointCollection(-30, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-30, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, 90, 0));
          break;
        case 'str05_01':
          retList.push(new marietta.webcad.collection.PointCollection(-30, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-30, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, 90, 0));
          break;
        case 'str06_01':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -60, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -60, 0));
          retList.push(new marietta.webcad.collection.PointCollection(60, 0, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 0, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 60, 0));
          break;
        case 'str07_01':
          retList.push(new marietta.webcad.collection.PointCollection(-30, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-30, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(30, 30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(30, 90, 1));
          break;
        case 'str08_01':
        case 'str08_02':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, 30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 30, 0));
          break;
        case 'str09_01':
        case 'str09_02':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, 90, 1));
          break;
        case 'str10_01':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(60, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, 30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(60, 90, 1));
          break;
        case 'str11_01':
        case 'str11_02':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(-60, 30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -90, 0));
          retList.push(new marietta.webcad.collection.PointCollection(60, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 90, 1));
          break;
        case 'str12_01':
        case 'str12_02':
          retList.push(new marietta.webcad.collection.PointCollection(-60, 90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(-60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -90, 1));
          retList.push(new marietta.webcad.collection.PointCollection(60, -30, 0));
          retList.push(new marietta.webcad.collection.PointCollection(0, -30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 30, 1));
          retList.push(new marietta.webcad.collection.PointCollection(0, 90, 0));
          break;
        default:

          break;
      }
      // guidを追加
      for (let i = 0; i < retList.length; i += 1) {
        retList[i].guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      return (retList.length > 0) ? retList : null;
    }

    /**
     * 階段のサイズ情報の取得
     */
    static getStairSize(id: string): { width: number, height: number } {
      switch (id) {
        case 'str01_01':
        case 'str02_01':
        case 'str02_02':
        case 'str06_01':
          return { width: 120, height: 120 };
        case 'str03_01':
        case 'str04_01':
        case 'str05_01':
        case 'str07_01':
          return { width: 60, height: 180 };
        case 'str08_01':
        case 'str08_02':
        case 'str09_01':
        case 'str09_02':
        case 'str10_01':
        case 'str11_01':
        case 'str11_02':
        case 'str12_01':
        case 'str12_02':
          return { width: 120, height: 180 };
        default:
          return null;
      }
    }

    static isRoomForFloorEndItem( room:MonicaObject ):boolean{
      switch (room.itemInfo.id.substring(0,5)){
        case 'rom01':   //'ポーチ'
        case 'rom03':   //'玄関'
        case 'rom09':   //'浴室'
        case 'rom17':    //'吹抜'
        case 'rom18':    //'ﾊﾞﾙｺﾆｰ'
        case 'rom27':    //'ｶﾞﾚｰｼﾞ'
        case 'rom28':    //'土間'
        case 'rom36':    //'PS'
        case 'rom37':    //'MB'
          return false;
      }
      return true;
    }

    /**
     * 和室の畳模様の選定
     */
    static getWashituDesign(info: marietta.webcad.collection.ItemInfoCollection): string {
      // サイズの計測
      let minX: number;
      let minY: number;
      let maxX: number;
      let maxY: number;
      for (let i: number = 0; i < info.dotList.length; i += 1) {
        if (minX === undefined || info.dotList[i].x < minX) minX = info.dotList[i].x;
        if (minY === undefined || info.dotList[i].y < minY) minY = info.dotList[i].y;
        if (maxX === undefined || info.dotList[i].x > maxX) maxX = info.dotList[i].x;
        if (maxY === undefined || info.dotList[i].y > maxY) maxY = info.dotList[i].y;
      }
      const w: number = Math.round(((maxX - minX) / marietta.webcad.WebCADGlobal.PIX_IN_GRID) * 10) / 10;
      const h: number = Math.round(((maxY - minY) / marietta.webcad.WebCADGlobal.PIX_IN_GRID) * 10) / 10;
      switch (w) {
        case 2:
          switch (h) {
            case 3: return 'tatami_1';
            case 4: return 'tatami_2';
            default: break;
          }
          break;
        case 3:
          switch (h) {
            case 2: return 'tatami_9';
            case 3: return 'tatami_19';
            case 4: return 'tatami_12';
            case 5: return 'tatami_14';
            case 6: return 'tatami_16';
            default: break;
          }
          break;
        case 4:
          switch (h) {
            case 2: return 'tatami_10';
            case 3: return 'tatami_4';
            case 4: return 'tatami_5';
            case 5: return 'tatami_15';
            case 6: return 'tatami_20';
            default: break;
          }
          break;
        case 5:
          switch (h) {
            case 3: return 'tatami_6';
            case 4: return 'tatami_7';
            default: break;
          }
          break;
        case 6:
          switch (h) {
            case 3: return 'tatami_8';
            case 4: return 'tatami_21';
            default: break;
          }
          break;
        default:
          break;
      }
      return '';
    }

    /**
     * 壁タイプ別、色番号の取得
     * @param int 部屋ID
     * @return Object color:色番号 alpha:壁の透明度
     * */
    static getColorForWallType(typeNumber: number): { color: string, alpha: number } {
      switch (typeNumber) {
        case 1: return { color: '#666666', alpha: 1 }; // 全面壁
        case 2: return { color: '#B89965', alpha: 1 }; // 腰壁
        case 3: return { color: '#CCCCCC', alpha: 1 }; // 框
        case 0: return { color: '#FFFFFF', alpha: 0 }; // 開口
        default: break;
      }
      return { color: '#666666', alpha: 1 };
    }

    /**
     * 階段の反転した際の文字のtransformStringを返す
     * @param int 部屋ID
     * @return Object color:色番号 alpha:壁の透明度
     * */
    static getTransformMatrixForReverseStairs(item: marietta.webcad.item.Stair): string {
      if (!item.itemInfo._lr) return 'matrix( 1, 0, 0, 1, 0,0) ';

      let scale: string = 'scale(-1,1)';
      let translate: string = 'translate(60, 0)';

      // アイテムによっては、位置を変更する
      switch (item.itemInfo.id) {
        case 'str02_02':
        case 'str08_02':
        case 'str09_02':
        case 'str12_02':
          translate = 'translate(-60, 0)';
          break;
        case 'str03_01':
        case 'str04_01':
        case 'str05_01':
        case 'str07_01':
          translate = '';
          break;
        case 'str10_01':
        case 'str10_02':
          translate = 'translate(0, -120)';
          scale = 'scale(1, -1)';
          break;
        case 'str11_02':
          translate = 'translate(0, 120)';
          scale = 'scale(1, -1)';
          break;
        default:
          break;
      }
      return `${scale} ${translate}`;
    }

    /**
     * 階段の反転した際の文字のtransformStringを返す
     * @param int 部屋ID
     * @return Object color:色番号 alpha:壁の透明度
     * */
    static getTransformMatrixForReverseUpStairs(partner: marietta.webcad.item.Stair): string {
      if (!partner.itemInfo._lr) return 'matrix( 1, 0, 0, 1, 0,0) ';

      let scale: string = 'scale(-1,1)';
      let translate: string = 'translate(-60, 0)';

      // アイテムによっては、位置を変更する
      switch (partner.itemInfo.id) {
        case 'str02_02':
        case 'str08_02':
        case 'str09_02':
        case 'str06_01':
        case 'str11_02':
        case 'str12_02':
          translate = 'translate(60, 0)';
          break;
        case 'str03_01':
        case 'str04_01':
        case 'str05_01':
        case 'str07_01':
          translate = '';
          break;
        case 'str10_01':
        case 'str11_01':
          translate = 'translate(0, 120)';
          scale = 'scale(1, -1)';
          break;
        default:
          break;
      }
      return `${scale} ${translate}`;
    }

    /**
     * Busyを表示中
     */
    static get isShowingBusy():boolean{
      return Boolean( 0 < WebCADGlobal.busyCounter );
    }

    /**
     * Busyを表示
     */
    static showBusy(message: string = '', callback: Function = null) {
      WebCADGlobal.busyCounter += 1;

      const p = new Promise((resolve: Function) => {
        (<HTMLElement> document.querySelector('.loadingContainer')).style.display = 'block';
        (<HTMLElement> document.querySelector('.loadingContainer .loadingText')).textContent = message;
        resolve(resolve);
      });
      p.then((resolve: Function) => {
        resolve();
      }).then(() => {
        if (callback) callback();
      }).catch((msg: any) => {
        console.log(msg);
      });
    }

    /**
     * Busyを非表示
     */
    static hideBusy() {
      // WebCADGlobal.busyCounter = Math.max(0, WebCADGlobal.busyCounter - 1);
      WebCADGlobal.busyCounter = 0;

      (<HTMLElement> document.querySelector('.loadingContainer')).style.display = 'none';
    }

    /**
     * Busyを非表示
     */
    static hideBusyStrict() {
      WebCADGlobal.busyCounter = Math.max(0, WebCADGlobal.busyCounter - 1);

      if (WebCADGlobal.busyCounter <= 0) {
        (<HTMLElement> document.querySelector('.loadingContainer')).style.display = 'none';
      }
    }

    /**
     * 出窓か否か
     * @id アイテムID
     * */
    static isDemado(id: String): boolean {
      if (id.indexOf('fit') < 0) return false;

      switch (id) {
        case 'fit18_01':
        case 'fit18_02':
        case 'fit19_01':
        case 'fit21_01':
        case 'fit20_01':
        case 'fit21_06':
        case 'fit21_07':
        case 'fit32_01':
          return true;
        default:
          return false;
      }
    }

  /**
   * アイテムをguidから検出
   */
  static getItemByGuid( guid:string, id:string = null ):MonicaObject{
    // アイテムを特定する
    let itemList: MonicaObject[] = [];
    if( id ){
      switch (id.substring(0, 3)) {
        case 'fit':
          itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO);
          itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO));
          break;
        case 'str':
          itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_STAIR_NO);
          break;
        case 'equ':
          itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EQUIPMENT_NO);
          break;
        case 'fur':
          itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FURNITURE_NO);
          break;
        case 'ext':
          itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EXTERIOR_NO);
          break;
        default:
          break;
      }
    }else{
      itemList = itemList.concat(
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_STAIR_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EQUIPMENT_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FURNITURE_NO),
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EXTERIOR_NO));
    }

    return (itemList.length > 0) ? itemList.find(item => item.itemInfo.guid === guid) : null;
  }

  /**
     * 2Dアイテムの情報更新
     * @param index 出力時のIndex
     * @param id アイテムID
     * @param info width, height,
     */
    static change2Dfrom3D(guid: string, id: string, info): void {
      let targetItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid( guid, id );

      // for (let i: number = 0; i < itemList.length; i += 1) {
      //   // if (((itemList[i]).itemInfo.createindex === createindex) && ((itemList[i]).itemInfo.id === id)) {
      //   //   targetItem = itemList[i];
      //   // }
      // }
      if (!targetItem) return;

      // 3DのID
      if (info.idthreed) {
        targetItem.itemInfo.idthreed = info.idthreed;
      }

      // 情報の引継ぎ
      if(  info.width !== undefined ){
        if (id.substring(0, 3) === 'fit') {
          if (info.width !== undefined) {
            // (targetItem as marietta.webcad.item.Fitting).changeFittingSize(marietta.webcad.util.WebCADUtil.convertMMToPix(info.width));
            (targetItem as marietta.webcad.item.Fitting).changeSize(info.width, 0, false);
          }
        } else if (info.width !== undefined) {
          // mm単位でのサイズ変更
          targetItem.changeSizeForNonWhiteItem(info.width, info.height, false);
        }
      }
    }

    // ビューモードフラグ
    static isViewCameraMode = true;

    static hasShownUseMapAlert:boolean = false;

    /**
     * 3D表示メニュー切替
     */
    static change3dMenu = (e) => {
      let items;
      const wtCamSet = document.querySelectorAll('.wtCamSet');
      const obCamSet = document.querySelectorAll('.obCamSet');
      switch (e.value) {
        case 0:
          for (let i = 0, len = wtCamSet.length; i < len; i += 1) {
            (<HTMLElement>wtCamSet[i]).style.display = 'none';
          }
          for (let i = 0, len = obCamSet.length; i < len; i += 1) {
            (<HTMLElement>obCamSet[i]).style.display = 'flex';
          }
          marietta.webcad.WebCADGlobal.miniMapManager.updateMinimapDisplayByBtn();

          // カーソルを手のマークにする
          $('#webcad3dView').css('cursor', `url(${this.webcad2Dmanager.assets_url}img/grab.cur), move`);
          break;
        case 1:
          for (let i = 0, len = wtCamSet.length; i < len; i += 1) {
            (<HTMLElement>wtCamSet[i]).style.display = 'flex';
          }
          for (let i = 0, len = obCamSet.length; i < len; i += 1) {
            (<HTMLElement>obCamSet[i]).style.display = 'none';
          }

          // 寸法線が表示されていた場合は非表示に
          if ((<HTMLInputElement>document.getElementById('btnMeasureLine3D').previousElementSibling).checked) document.getElementById('btnMeasureLine3D').click();

          // ワイヤーフレームが表示されていた場合は非表示に
          if ((<HTMLInputElement>document.getElementById('apprWireframe')).checked) document.getElementById('apprWireframe').click();

          // 建具がない場合は、アラートを表示する
          // 1Fに玄関がなければ、遷移しない
          items = ((marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1) as marietta.webcad.layer.FloorLayer).layer_fitting as marietta.webcad.layer.ItemLayer).getAllChildren();
          if (items.length < 1) {
            // "玄関が配置されていません。<br>建物の中へ移動する場合は、マップをクリックして移動してください。"
            // marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ALERT_NO_ENTRANCE'));
            if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D' && marietta.webcad.WebCADGlobal.hasShownUseMapAlert == false ) {
              marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ALERT_MOVE_MAP'));
              marietta.webcad.WebCADGlobal.hasShownUseMapAlert = true;    //１回のみ表示
            };
          }

          // カーソル切り替え
          if (this.isViewCameraMode) {
            // カーソルを通常のカーソルする
            $('#webcad3dView').css('cursor', `url(${this.webcad2Dmanager.assets_url}img/grab.cur), move`);
          } else {
            // カーソルを手のマークにする
            $('#webcad3dView').css('cursor', 'auto');
          }
          break;
        default: break;
      }
    }

    /**
     * 3Dメニューのボタン表示初期化
     */
    static init3dMenu() {
      // 3Dのフロアボタンを、階数に応じて表示する
      const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
      const obFloorLabel = document.querySelectorAll('#orbitFloorBtn3D label');
      obFloorLabel.forEach((elem:HTMLElement) => { elem.style.display = 'inline-block'; });
      const wtFloorLabel = document.querySelectorAll('#walkthroughFloorBtn3D label');
      wtFloorLabel.forEach((elem:HTMLElement) => { elem.style.display = 'inline-block'; });
      for (let i = marietta.webcad.WebCADGlobal.MAX_FLOORS; i > highestFloor; i -= 1) {
        (<HTMLElement>document.querySelectorAll('#orbitFloorBtn3D label')[i - 1]).style.display = 'none';
        (<HTMLElement>document.querySelectorAll('#walkthroughFloorBtn3D label')[i - 1]).style.display = 'none';
      }
      marietta.view3d.webcad.View3dGlobal.shared.updateMenus();

      // ミニマップの表示をボタンと同期
      marietta.webcad.WebCADGlobal.miniMapManager.updateMinimapDisplayByBtn();
    }

    /**
     * [3D]ConstructionModel --> [2D] modelParam へ反映
     */
    static setModelParamFromConstructionModel(jsonData) {
      const param = new marietta.webcad.collection.ModelParamCollection(
        jsonData.option,
        jsonData.height,
        jsonData.auto,
        jsonData.material,
      );
      this.autoMain.perseModelHeightXML(jsonData.height);
      this.autoMain.perseModelAutoXML(jsonData.auto);
      marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = param;
    }

    /**
     * 面積情報ダイアログの表示
     */
    static showAreaInfoDialog(): void {
      // ダイアログ表示
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PlanAreaInfo);
    }

    /**
     * コンフィグ情報の取得
     */
    static checkOnlineAnd(callBack: Function): void {
      const date = new Date();
      let url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}assets/config.xml?ts=${date.getTime()}`;

      // 開発環境
      if (window.location.href.indexOf('localhost') > -1) {
        url = 'assets/config.xml';
      }

      fetch(url, { method: 'GET' })
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.text();
          }
          throw Error(response.statusText);
        }).then(() => {
        // ONLINE
          callBack();
        }).catch(() => {
          // アラートを表示して以降は行わない
          // "オフラインです。<br>ネットワーク環境をご確認ください。"
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_OFFLINE'));
        });
    }

    /**
     * 3Dの自動回転アイテムか否かの判定
     */
    static isAutoFacingItem(key: string): boolean {
      for (let i: number = 0; i < marietta.webcad.WebCADGlobal.AUTOFACING_ITEMS.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.AUTOFACING_ITEMS[i] === key) return true;
      }

      return false;
    }


  /**
   * 3Dを持たないアイテムか否か
   */
  static isNo3dItem(key: string): boolean {
    for (let i: number = 0; i < marietta.webcad.WebCADGlobal.NON3D_ITEMS.length; i += 1) {
      if (marietta.webcad.WebCADGlobal.NON3D_ITEMS[i] === key) return true;
    }

    return false;
  }


  /**
     * 3Dリクエストのタイムアウト・アラート表示
     */
    static showAlertForRequest3DTimeOut(): void {
      // FitWindow
      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();

      marietta.webcad.WebCADGlobal.hideBusy();
      // "ただいま、サーバが大変混み合っております。しばらくしてから、お試しください。"
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_SERVER_BUSY'));
    }

    /**
     * デバイスに応じて機能制限
     */
    static controlWebCADFuncByUA(): void {
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isPC) {
        const jsNotForPc = document.querySelectorAll('.js-notForPC');
        for (let i = 0, len = jsNotForPc.length; i < len; i += 1) {
          (<HTMLElement>jsNotForPc[i]).remove();
        }
      } else {
        const jsForPc = document.querySelectorAll('.js-forPC');
        for (let i = 0, len = jsForPc.length; i < len; i += 1) {
          (<HTMLElement>jsForPc[i]).remove();
        }
      }

      if (ua.isMobile) {
        const jsNotForMobile = document.querySelectorAll('.js-notForMobile');
        for (let i = 0, len = jsNotForMobile.length; i < len; i += 1) {
          (<HTMLElement>jsNotForMobile[i]).remove();
        }
      } else {
        const jsForMobile = document.querySelectorAll('.js-forMobile');
        for (let i = 0, len = jsForMobile.length; i < len; i += 1) {
          (<HTMLElement>jsForMobile[i]).remove();
        }
      }

      if (ua.isTablet) {
        const jsNotForTablet = document.querySelectorAll('.js-notForTablet');
        for (let i = 0, len = jsNotForTablet.length; i < len; i += 1) {
          (<HTMLElement>jsNotForTablet[i]).remove();
        }
      } else {
        const jsForTablet = document.querySelectorAll('.js-forTablet');
        for (let i = 0, len = jsForTablet.length; i < len; i += 1) {
          (<HTMLElement>jsForTablet[i]).remove();
        }
      }
    }

    /**
     * 言語変更
     */
    static changeViewByLanguage(val: string): void {
      if (val === marietta.webcad.WebCADGlobal.language) return;
      if (val !== 'jp' && val !== 'en') return;
      // marietta.webcad.WebCADGlobal.showBusy('');
      switch (val) {
        case 'jp':
          document.querySelector('body').classList.remove('lang-en');
          document.querySelector('body').classList.add('lang-jp');
          break;
        case 'en':
          document.querySelector('body').classList.remove('lang-jp');
          document.querySelector('body').classList.add('lang-en');
          break;
        default: break;
      }
      marietta.webcad.WebCADGlobal.language = val;
      // marietta.webcad.WebCADGlobal.hideBusy();
    }

    /**
     * 建具設定のパース＆保持
     */
    static parseFittingSetting(infoXML: HTMLElement): void {
      const info: marietta.webcad.collection.FittingSettingCollection = new marietta.webcad.collection.FittingSettingCollection();
      info.id = infoXML.getAttribute('id');
      info.defaultHeight = infoXML.getAttribute('defaultHeight');
      info.defaultZ = infoXML.getAttribute('defaultZ');
      info.heightList = (infoXML.querySelector('select') as any);
      marietta.webcad.WebCADGlobal.FITTING_CONFIG_ITEMS.push(info);
    }

    /**
     * 屋根の入力を全て削除して屋根の自動生成
     */
    static resetAllRoofAndReload3D(): void {
      // 屋根を全て削除する
      this.layerGroup.floor1.layer_roof.removeAllChildren();
      this.layerGroup.floor2.layer_roof.removeAllChildren();
      this.layerGroup.floor3.layer_roof.removeAllChildren();

      // 3Dをリロードする
      marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D();

      // 表示するボタンの切替
      document.querySelectorAll(('.autoRoof')).forEach((elem:HTMLElement) => { elem.style.display = 'block'; });
      document.querySelectorAll(('.manualRoof')).forEach((elem:HTMLElement) => { elem.style.display = 'none'; });
    }

    /**
     * 面積情報ダイアログの表示
     */
    static showSekisanInfoDialog(): void {
      // ダイアログ表示
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SekisanDialog);
    }

    /**
     * 高さが設定可能なアイテムか否か
     */
    static isHeightSettingEnableFitting(id: string): boolean {
      switch (id) {
        case 'fit01_01':
        case 'fit01_02':
        case 'fit01_03':
        // case 'fit02_01':
        case 'fit02_07':
          return false;
        default:
          return true;
      }
    }

  /**
   * 高さが設定可能なアイテムか否か
   */
  static isCapableOfHavingEndItemFitting(id: string): boolean {
    switch (id) {
      case 'fit01_01':
      case 'fit01_02':
      case 'fit01_03':
        return true;
      default:
        return false;
    }
  }


  /**
     * 壁アイテムの高さが設定可能かどうか
     */
    static isHeightSettingEnableWall(id: string): boolean {
      switch (id) {
        case 'fit01_02':
        case 'fit01_03':
          return true;
        default:
          return false;
      }
    }

    /**
     * 敷地の入力有無
     */
    static hasSiteInput(): boolean {
      const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
      const itemList: any[] = tarLayer.getAllChildren();
      return Boolean(itemList.length);
    }

    /**
     * 部屋の入力有無
     */
    static hasRoomInput(): boolean {
      let itemList: any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO);
      itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO));
      itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO));

      return Boolean(itemList.length);
    }

    // WebGL対応有無
    static capableWebGL(): boolean {
      try {
        const canvas = document.createElement('canvas');
        const webGLContext: any = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        return !!(window.WebGLRenderingContext && webGLContext && webGLContext.getShaderPrecisionFormat);
      } catch (error) {
        return false;
      }
    }

    // アイテムを貼り付けるとき
    static isItemAllowedOnCurrentFloor(id: string): boolean {
      const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      let status : boolean = true;
      if (currentFloor === 1) {
        switch (id) {
          case 'rom17_01':
          case 'rom18_01':
            status = false;
            break;
          default: break;
        }
      } else {
        switch (id) {
          case 'rom01_01':
          case 'rom27_01':
            status = false;
            break;
          default: break;
        }
        if (id.substring(0, 3) === 'ext' || id.substring(0, 3) === 'sit') status = false;
      }

      if (id === 'rom18_01' && marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) status = true;
      return status;
    }

    /**
     * 階数変更
     * @param {number} floor
     */
    static changeFloor(floor: number): void {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor !== floor) {
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor = floor;
      document.querySelectorAll('input[name=currentFloor2d]').forEach((element:HTMLInputElement) => {
        if (parseInt(element.value, 10) === floor - 1) element.checked = true;
      });
      this.onFloorChanged(floor);
    }

    /**
     * ページ遷移しようとしている
     */
    static pageBeforeUnload = () => {
      // ローカル開発環境の場合は実行しない
      const url: string = window.location.href;
      if (url.indexOf('localhost') > -1) return;

      // 変更フラグがなければ表示しない
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged) return;

      // eslint-disable-next-line consistent-return
      return marietta.webcad.collection.WebCADMessages.getText('NOTICE_DATA_NOSAVE');
    }

    /**
     * 測定線を更新
     * @return void
     * @param currentItemCheck type: boolean, default = true, 現在のアイテムタイプの確認
     * @param currentItemCheck type: boolean, default = true, 現在のstairItemを確認する
    * */
    static updateMeasureLine(currentItemCheck = true, strairCheck = true) {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement) {
        // 単一アイテムのハンドル
        if (currentItemCheck) {
          if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
            const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
            const targetKey = targetId.substring(0, 3);
            // チェック対象はroomTypeです
            if (targetKey === ITEM_MODE_KEY.MODE_ROOM_KEY) {
              marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine(true);
              // チェック対象はStairTypeです
            } else if (targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
              // strairCheckパラメーターは、何らかの条件で階段項目タイプを確認するために使用されます.
              // たとえば、stairItemを作成するときは、ItemManager.createItem関数でdrawMeasureLineを使用しないでください. strairCheckパラメーター = false
              if (strairCheck) {
                marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine(true);
              }
            }
          }
          // groupItemハンドル
        } else if (this.itemManager.currentItemGroup && this.itemManager.currentItemGroup.hasLineMeasurementItem()) {
          // ターゲットはgroupItemチェックです
          // groupItemに測定項目が含まれていることを確認
          marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine(true);
        } else {
          marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine(true);
        }
      }
    }

    /**
     * WebCADのアクティベーションチェック
     * ※多数台での起動が確認されたら、アラートを出して終了
     */
    static activatableCheck(callBack:Function):void {
      const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_activation_url}/keys`;
      const data = {
        domain: marietta.webcad.WebCADGlobal.webcad2Dmanager.domain,
        user_id: marietta.webcad.WebCADGlobal.webcad2Dmanager.userID,
      };
      const headers = {
        Accept: 'application/json',
        credentials: 'include',
      };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers,
      }).then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        }
        throw Error(response.statusText);
      }).then(() => {
        // 成功時
        if (callBack != null) {
          callBack();
        }
      }).catch((XMLHttpRequest) => {
        // オブジェクト形式に変更
        const retData = JSON.parse(XMLHttpRequest.responseText);

        let msg = retData.error.message;
        if (retData.data.list != null && retData.data.list !== undefined) {
          msg += '<br><br>●使用状況';

          let loginInfo;
          for (let i:number = 0; i < retData.data.list.length; i += 1) {
            loginInfo = retData.data.list[i];
            msg += '<br>';
            msg += `${loginInfo.activated_at} ${loginInfo.platform} - ${loginInfo.browser}`;
          }
        }
        // チェックに引っかかった
        // アラート表示
        marietta.webcad.WebCADGlobal.showActivationErrorAlert(msg);
      });
    }

    static convertToNewPattern(designType:string):string {
      let pattern = '';
      switch (designType) {
        case 'koushi_3':
        case 'pattern_7':
          pattern = 'koushi_1';
          break;
        case 'pattern_8':
        case 'pattern_34':
          pattern = 'pattern_4';
          break;
        default:
          pattern = '';
          break;
      }
      return pattern;
    }

    /**
     * guid
     * @returns
     */
    static getGuid() {
      let uuid = '';
      let i: number;
      let random;
      for (i = 0; i < 32; i += 1) {
        // eslint-disable-next-line no-bitwise
        random = Math.random() * 16 | 0;

        if (i === 8 || i === 12 || i === 16 || i === 20) {
          uuid += '-';
        }
        // eslint-disable-next-line no-nested-ternary, no-bitwise, no-mixed-operators
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
      }
      return uuid;
    }

    /**
     * WallDecorationDef.xml dataに itemid が存在することをチェック
     * @param itemID
     * @returns
     */
    static doesItemSupportZPositioning(itemID: string): Boolean {
      if (marietta.webcad.WebCADGlobal.wallDecorationDefItemCodeList.includes(itemID)) {
        return true;
      }
      return false;
    }

    /**
     * 2Dで高さ・設置高さを編集できるアイテムか（天井アイテムは天井基準で z を持つため除く）
     * @param itemID
     */
    public static isHeightEditableItem(itemID: string): boolean {
      if (HEIGHT_EDITABLE_ITEM_PREFIXES.indexOf(itemID.substring(0, ITEM_ID_PREFIX_LENGTH)) === -1) return false;
      return marietta.webcad.WebCADGlobal.ceilingItemCodeList.indexOf(itemID) === -1;
    }

    /**
     * 表示に使う高さ(mm)。高さ編集の対象で未設定なら、マスタ（グレード）→ PartsDef（idthreed、無ければ id）の順に補う
     * 保存・3D連携の値（depth）は書き換えない
     */
    public static getItemHeight(info: marietta.webcad.collection.ItemInfoCollection): number {
      if (info.depth > 0 || !marietta.webcad.WebCADGlobal.isHeightEditableItem(info.id)) return info.depth;

      const masterHeight = info.end_item_info?.item_height;
      if (masterHeight > 0) return masterHeight;

      const { partsDefObjectData } = marietta.webcad.WebCADGlobal;
      return partsDefObjectData[info.idthreed]?.height ?? partsDefObjectData[info.id]?.height ?? info.depth;
    }

    /**
     * 表示に使う幅・奥行・高さ(mm)。フッターのサイズ欄と仕様情報の行で同じ値を出すために使う
     * 住設・家具で商品が付いていればマスタの値、それ以外はアイテムの値（高さは getItemHeight の補いを含む）
     */
    public static getItemSize(info: marietta.webcad.collection.ItemInfoCollection): { width: number, depth: number, height: number } {
      const master: marietta.webcad.collection.MasterItemCollection = info.end_item_info;
      if (master && marietta.webcad.WebCADGlobal.isHeightEditableItem(info.id)) {
        return { width: master.item_width, depth: master.item_depth, height: master.item_height };
      }
      return { width: info.widthmm, depth: info.heightmm, height: marietta.webcad.WebCADGlobal.getItemHeight(info) };
    }

    /**
     * WallDecorationDef xml を読み込む
     * @param callBack
     */
    static loadWallDecorationDef = (): void => {
      let url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}assets/3d/WallDecorationDef.xml`;

      // 開発環境
      if (window.location.href.indexOf('localhost') > -1) {
        url = './assets/3d/WallDecorationDef.xml';
      }
      fetch(url, { method: 'GET' })
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.text();
          }
          throw Error(response.statusText);
        }).then((info) => {
          const datXML = new window.DOMParser().parseFromString(info, 'text/xml');
          marietta.webcad.WebCADGlobal.parseWallDecorationDefData(datXML);
        }).catch(() => {
          // 何もしない
          marietta.webcad.WebCADGlobal.showAlert('Configの取得に失敗しました。\n恐れ入りますが、リロードして下さい。');
        });
    }

    static wallDecorationDefItemCodeList = [];
    static wallDecorationDefItemDataList = [];

    /**
     * WallDecorationDef.xml データを解析する
     * @param datXML
     */
    static parseWallDecorationDefData(datXML: any): void {
      const parts = (datXML).querySelector('Data').querySelector('parts');
      if (parts != null) {
        const itemList = parts.querySelectorAll('item');
        if (itemList.length > 0) {
          for (let i = 0; i < itemList.length; i += 1) {
            if (itemList[i].getAttribute('id')) {
              // プッシュアイテムID
              marietta.webcad.WebCADGlobal.wallDecorationDefItemCodeList.push(itemList[i].getAttribute('id'));
              marietta.webcad.WebCADGlobal.wallDecorationDefItemDataList.push({
                id: itemList[i].getAttribute('id'),
                width: parseFloat(itemList[i].getAttribute('width')),
                height: parseFloat(itemList[i].getAttribute('high')),
                depth: parseFloat(itemList[i].getAttribute('depth')),
              });
            }
            if (itemList[i].querySelector('alternative')) {
              const altItemList = itemList[i].querySelector('alternative').querySelectorAll('alt_item');
              if (altItemList.length > 0) {
                for (let j = 0; j < altItemList.length; j += 1) {
                  if (altItemList[j].getAttribute('id')) {
                    // 代替アイテム ID をプッシュ
                    marietta.webcad.WebCADGlobal.wallDecorationDefItemCodeList.push(altItemList[j].getAttribute('id'));
                    marietta.webcad.WebCADGlobal.wallDecorationDefItemDataList.push({
                      id: altItemList[j].getAttribute('id'),
                      width: parseFloat(altItemList[j].getAttribute('width')),
                      height: parseFloat(altItemList[j].getAttribute('high')),
                      depth: parseFloat(altItemList[j].getAttribute('depth')),
                    });
                  }
                }
              }
            }
          }
        }
      }
    }

    /**
     *partsnDef xml を読み込む
     * @param callBack
     */
     static loadPartsDef = (): void => {
       let url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}assets/3d/PartsDef.xml`;

       // 開発環境
       if (window.location.href.indexOf('localhost') > -1) {
         url = './assets/3d/PartsDef.xml';
       }
       fetch(url, { method: 'GET' })
         .then((response) => {
           if (response.status >= 200 && response.status <= 299) {
             return response.text();
           }
           throw Error(response.statusText);
         }).then((info) => {
           const datXML = new window.DOMParser().parseFromString(info, 'text/xml');
           marietta.webcad.WebCADGlobal.parsePartsDefData(datXML);
         }).catch((e) => {
           // 何もしない
           console.log(e);
           marietta.webcad.WebCADGlobal.showAlert('Configの取得に失敗しました。\n恐れ入りますが、リロードして下さい。');
         });
     }

    static ceilingItemCodeList = [];

    static partsDefObjectData = {};

    /**
     * PartsDef.xml データを解析する
     * @param datXML
     */
    static parsePartsDefData(datXML: XMLDocument): void {
      const parts = (datXML).querySelector('Data').querySelector('parts');
      if (parts != null) {
        const itemList = parts.querySelectorAll('item');
        if (itemList.length > 0) {
          for (let i = 0; i < itemList.length; i += 1) {
            const id = itemList[i].getAttribute('id');
            if (itemList[i].hasAttribute('id')) {
              marietta.webcad.WebCADGlobal.partsDefObjectData[id] = {};
              if (itemList[i].hasAttribute('high')) {
                marietta.webcad.WebCADGlobal.partsDefObjectData[id]['height'] = parseFloat(itemList[i].getAttribute('high'));
                marietta.webcad.WebCADGlobal.partsDefObjectData[id]['name'] = itemList[i].getAttribute('name');
              }
            }
            if (itemList[i].getAttribute('id') && itemList[i].getAttribute('is_ceiling_item') === 'true') {
              // プッシュアイテムID
              marietta.webcad.WebCADGlobal.ceilingItemCodeList.push(itemList[i].getAttribute('id'));
            }
            if (itemList[i].querySelector('alternative')) {
              const altItemList = itemList[i].querySelector('alternative').querySelectorAll('alt_item');
              for (let j = 0; j < altItemList.length; j += 1) {
                const altId = altItemList[j].getAttribute('id');
                if (altItemList[j].hasAttribute('id')) {
                  marietta.webcad.WebCADGlobal.partsDefObjectData[altId] = {};
                  if (altItemList[j].hasAttribute('high')) {
                    marietta.webcad.WebCADGlobal.partsDefObjectData[altId]['height'] = parseFloat(altItemList[j].getAttribute('high'));
                  }
                }
                if (altItemList[j].getAttribute('id') && altItemList[j].getAttribute('is_ceiling_item') === 'true') {
                  // 代替アイテム ID をプッシュ
                  marietta.webcad.WebCADGlobal.ceilingItemCodeList.push(altItemList[j].getAttribute('id'));
                }
              }
            }
          }
        }
      }
      console.log(marietta.webcad.WebCADGlobal.partsDefObjectData);
    }

    /**
     * フリーテキストアイテムを確認してください
     * @return boolean
     */
    static isFreeTextItem(id: string): boolean {
      if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${FREETEXT_ITEMCODE}`) > -1) {
        return true;
      }
      return false;
    }

    /**
     * ceilingItemCodeList itemid が存在することをチェック
     * @param itemID
     * @returns
     */
    static IsCeilingItem(itemID: string): Boolean {
      if (marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(itemID)) {
        return true;
      }
      return false;
    }

    /**
     * パイント テキスト アイテムをチェックするかどうか
     * @return boolean
     */
    static isPinTextItem(id: string): boolean {
      for (let i = 0; i < this.pinTextCategory.length; i += 1) {
        if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${this.pinTextCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    /**
     * パイント テキスト アイテムをチェックするかどうか
     * @return boolean
     */
    static isPinPictureItem(id: string): boolean {
      for (let i = 0; i < this.pinPictureCategory.length; i += 1) {
        if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${this.pinPictureCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    static PinTextItemNumber(id: string): number {
        for (let i = 0; i < this.pinTextCategory.length; i += 1) {
            if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${this.pinTextCategory[i].item_code}`) > -1) {
              return this.pinTextCategory[i].id;
            }
          }
          return -1;
    }

    static isPinPanoramaItem(id: string): boolean {
      for (let i = 0; i < this.pinPanoramaCategory.length; i += 1) {
        if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${this.pinPanoramaCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    static PinPanoramaItemNumber(id: string): number {
        for (let i = 0; i < this.pinTextCategory.length; i += 1) {
            if (id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${this.pinPanoramaCategory[i].item_code}`) > -1) {
              return this.pinPanoramaCategory[i].id;
            }
          }
          return -1;
    }

    /**
     *すべてのピン テキスト アイテムを取得する
    */
    static getPinTextItems() {
      const itemList: marietta.webcad.item.FreeText[] = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO);
      const pinItemList = [];
      for (let i = 0; i < itemList.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.isPinTextItem(itemList[i].itemInfo.id) == false &&
            marietta.webcad.WebCADGlobal.isPinPanoramaItem(itemList[i].itemInfo.id) == false) continue;
        const obj = {
          id: itemList[i].itemInfo.id,
          guid: itemList[i].itemInfo.guid,
          floor: itemList[i].itemInfo.floor,
          width: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.width).toFixed(2)),
          height: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.height).toFixed(2)),
          text: itemList[i].itemInfo.text,
          x: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.x).toFixed(2)),
          // y: Number.parseFloat((-(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.y) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H))).toFixed(2)),
          y: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.y).toFixed(2)),
          z: Number.parseFloat(itemList[i].itemInfo.z.toFixed(2)),
        };
        pinItemList.push(obj);
      }
      return pinItemList;
    }

    /**
     *すべてのピン テキスト アイテムを取得する
    */
     static getPinPictureItems() {
      const itemList: marietta.webcad.item.FreeText[] = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO);
      const pinItemList = [];
      for (let i = 0; i < itemList.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.isPinPictureItem(itemList[i].itemInfo.id) == false) continue;
        const obj = {
          id: itemList[i].itemInfo.id,
          guid: itemList[i].itemInfo.guid,
          floor: itemList[i].itemInfo.floor,
          text: itemList[i].itemInfo.text,
          x: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.x).toFixed(2)),
          y: Number.parseFloat(marietta.webcad.util.WebCADUtil.convertPixToMM(itemList[i].itemInfo.y).toFixed(2)),
          z: Number.parseFloat(itemList[i].itemInfo.z.toFixed(2)),
          transformMatrix: itemList[i].itemInfo.transformMatrix
        };
        pinItemList.push(obj);
      }
      return pinItemList;
    }

    /**
     * カテゴリに基づいてピン テキスト ID を取得する
     */
    static getPinPictureId(): string {
      let code = '03_01';
      return `${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${code}`;
    }

    /**
     * カテゴリに基づいてピン テキスト ID を取得する
     * @param category number
     */
    static getPinTextId(categoryId: number = 1): string {
      const category = (marietta.webcad.WebCADGlobal.pinTextCategory as any).filter((item: any) => item.id === categoryId);
      let code = '02_01';
      if (category.length > 0) {
        code = category[0].item_code;
      }
      return `${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${code}`;
    }

    /**
     * カテゴリに基づいてパノラマピンID を取得する
     */
    static getPinPanoramaId(categoryId: number): string {
      const category = (marietta.webcad.WebCADGlobal.pinPanoramaCategory as any).filter((item: any) => item.id === categoryId);
      const code = (category.length > 0) ? category[0].item_code : '04_01';
      return `${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${code}`;
    }

    /**
     * チェックピンのテキストは ID からのウォールテキストです
     * @param id item id
     */
    static isWallPinText(id: string): boolean {
      const idData = id.split(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}`);
      if (idData.length > 1) {
        const category = (marietta.webcad.WebCADGlobal.pinTextCategory as any).filter((item: any) => item.item_code === idData[1] && item.id === 2);
        if (category.length > 0) {
          return true;
        }
      }
      return false;
    }

    /**
     * 3D ダイアログにピン テキストを表示
     * @param guid
     */
     static showPinText3D(guid: string) {
      const param = {
        guid: guid,
      };
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinTextInput3DDialog, false, false, false, false, param);
    }

    /**
     * 見積に含めるアイテムか否か
     */
    static isItemForQuotation( id:string ):boolean{
      if( -1 < id.indexOf("fit01_01") )return false;
      if( -1 < id.indexOf("fit01_02") )return false;
      if( -1 < id.indexOf("fit01_03") )return false;
      if( -1 < id.indexOf("fit02_01") )return false;

      if( -1 < id.indexOf("fur") )return true;
      if( -1 < id.indexOf("equ") )return true;
      if( -1 < id.indexOf("fit") )return true;
      if( -1 < id.indexOf("fur52_01") )return true;
      if( -1 < id.indexOf("fur35_01") )return true;
      if( -1 < id.indexOf("fur28_02") )return true;
      if( -1 < id.indexOf("fur28_03") )return true;

      if( -1 < id.indexOf("ext10_01") )return true;
      if( -1 < id.indexOf("ext18_01") )return true;
      if( -1 < id.indexOf("ext04_01") )return true;
      if( -1 < id.indexOf("ext06_01") )return true;
      if( -1 < id.indexOf("ext13_01") )return true;
      return false;
    }

    /**
     * webcad 終了時の LiDAR ページ遷移
     */
    static backLiDARPage() {
      location.href = this.webcad2Dmanager.lidar_url || location.origin;
    }

    /**
     * フィッティングIDに基づいてheight値を取得します
     * @param id
     */
    static getFittingHeight(id: string): number {
      let height: number = 0;
      switch (id) {
        case 'fit01_01':
          height = 2100;
          break;
        case 'fit01_02':
          height = 500;
          break;
        case 'fit01_03':
          height = 1100;
          break;
        case 'fit02_01':
          height = 2100;
          break;
        default:
          if (marietta.webcad.WebCADGlobal.partsDefObjectData) {
            if (marietta.webcad.WebCADGlobal.partsDefObjectData[id]) {
              if (marietta.webcad.WebCADGlobal.partsDefObjectData[id].hasOwnProperty('height')) {
                height = marietta.webcad.WebCADGlobal.partsDefObjectData[id]['height'];
              }
            }
          }
          break;
      }
      return height;
    }
}
